/**
 * The "Web購入" button and the button rows below it (テキストライブ /
 * 対戦相手情報, PRE-MATCH VOICE / POST MATCH VOICE) must always render at
 * the same width, regardless of which of these rows exist for a given
 * game and regardless of viewport (PC or SP). Since the label text is
 * identical across every game item, we measure the natural (unconstrained)
 * width of every instance on the page and apply the largest one to all of
 * them, so none of them is ever bigger/smaller depending on its siblings.
 * The button font-size is kept small enough (see CSS) that this shared
 * width still comfortably fits the content, and text is allowed to wrap
 * on SP as a safety net.
 */
document.addEventListener('DOMContentLoaded', function () {
  function syncPurchaseGroupWidths() {
    const buttons = document.querySelectorAll('.games-match-item__webpurchase');
    const voiceRows = document.querySelectorAll('.games-match-item-horizontal__action-row');

    if (buttons.length === 0 && voiceRows.length === 0) return;

    buttons.forEach((btn) => {
      btn.style.width = '';
    });
    voiceRows.forEach((row) => {
      row.style.width = '';
    });

    let maxWidth = 0;
    buttons.forEach((btn) => {
      maxWidth = Math.max(maxWidth, btn.getBoundingClientRect().width);
    });
    voiceRows.forEach((row) => {
      maxWidth = Math.max(maxWidth, row.getBoundingClientRect().width);
    });

    if (maxWidth <= 0) return;

    const widthPx = `${maxWidth}px`;
    buttons.forEach((btn) => {
      btn.style.width = widthPx;
    });
    voiceRows.forEach((row) => {
      row.style.width = widthPx;
    });
  }

  syncPurchaseGroupWidths();
  window.addEventListener('load', syncPurchaseGroupWidths);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncPurchaseGroupWidths, 150);
  });
});
